"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bag = void 0;
const react_1 = __importDefault(require("react"));
const Bag = ({ size, color, outline }) => {
    if (outline) {
        return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 51", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("rect", { x: "2.36516", y: "14.0239", width: "45.1154", height: "34.5735", rx: "10.7453", stroke: color || '#2EB3B4', strokeWidth: "2.88462" }),
            react_1.default.createElement("path", { d: "M15.3382 18.4866C14.2696 10.5589 15.3958 2.35315 23.6675 1.98145C33.7901 1.52658 34.7649 8.87672 34.1584 18.3351", stroke: color || '#2EB3B4', strokeWidth: "3.68227", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 54 53", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("rect", { x: "1.54053", y: "13.2622", width: "50.8804", height: "39.6867", rx: "12.8983", fill: color || '#25CFBB' }),
        react_1.default.createElement("path", { d: "M17.1626 19.5575C16.0317 11.1674 17.2235 2.48317 25.9776 2.0898C36.6905 1.6084 37.7221 9.38715 37.0803 19.3971", stroke: color || '#25CFBB', strokeWidth: "3.897", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.Bag = Bag;
